<template>
  <div class="modal sign-modal recover-modal">
    <div class="overlay" @click="$parent.closeRecover"></div>
    <div class="wrapper">
      <img
        class="close"
        @click="$parent.closeRecover"
        src="./../images/close.svg"
      />
      <div class="container">
        <form v-if="!showSuccess" @submit.prevent="submitRecover" class="form">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title">Forgot password?</div>
                <label>
                  <input
                    required
                    type="email"
                    v-model="email"
                    placeholder="E-mail address"
                  />
                </label>
                <button class="button" type="submit">
                  <span>Recover</span>
                </button>
                <div v-if="error" class="desc red">
                  {{ error }}
                </div>
              </div>
            </div>
          </div>
        </form>
        <div v-else class="submit-success">
          <div class="title">Please, check your email.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecoverModal",
  props: [],
  components: {},
  data: function () {
    return {
      email: "",
      showSuccess: "",
      error: "",
    };
  },
  mounted() {},
  computed: {},
  methods: {
    submitRecover() {
      let data = {
        email: this.email,
      };

      this.$http
        .post(process.env.VUE_APP_API + "user/request-password-reset", data)
        .then((res) => {
          if (res.data.status == "OK") {
            this.showSuccess = true;
          } else {
            this.error = res.response.data.msg;
          }
        })
        .catch((error) => {
          this.error = error.response.data.msg;
        });
    },
  },
};
</script>
